import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { compose, withProps, onlyUpdateForKeys, setDisplayName } from 'recompose';
import { withRouter } from 'react-router-dom';

import { withClassname } from '@components/hoc/withClassname';

import { TripsForm } from '@modules/trips/TripsForm';
import { ActionBar } from '@modules/trips/TripsGridButtons';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';

export const tripsUrl = '/metropolis/api/cl/trip';
export const tripsLabel = 'Služební jízdy';
export const tripsPath = '/trips';
export const tripsGridName = 'Trips';
export const TripsGrid = compose(
  withRouter,
  setDisplayName(tripsGridName),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: tripsLabel }]),
  withColumns(Agenda.TRIPS),
  withProps(({ history, columns }) => ({
    name: tripsGridName,
    url: tripsUrl,
    Form: TripsForm,
    dialog: false,
    gridProps: {
      columns,
      ActionBar,
      filterRow: true,
      history,
      showCheckboxes: true,
      deleting: true,
      filtering: true,
      sort: 'created',
      locale: 'cz',
      adding: true,
      version: 2,
      pageSize: 50
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/trips/TripsGrid.tsx